import { colorTokens } from "../colors/index.js";
export const sdbThemeDarkSystemTokens = {
    white: "#000000",
    black: "#ffffff",
    primary: {
        main: colorTokens.primary[40],
        on: colorTokens.primary[20],
        container: colorTokens.primary[30],
        onContainer: colorTokens.primary[90],
        fixed: colorTokens.primary[90],
        onFixed: colorTokens.primary[10],
        fixedDim: colorTokens.primary[80],
        onFixedVariant: colorTokens.primary[30],
    },
    secondary: {
        main: colorTokens.secondary[80],
        on: colorTokens.secondary[20],
        container: colorTokens.secondary[30],
        onContainer: colorTokens.secondary[90],
        fixed: colorTokens.secondary[90],
        onFixed: colorTokens.secondary[10],
        fixedDim: colorTokens.secondary[80],
        onFixedVariant: colorTokens.secondary[30],
    },
    tertiary: {
        main: colorTokens.tertiary[80],
        on: colorTokens.tertiary[20],
        container: colorTokens.tertiary[30],
        onContainer: colorTokens.tertiary[90],
        fixed: colorTokens.tertiary[90],
        onFixed: colorTokens.tertiary[10],
        fixedDim: colorTokens.tertiary[80],
        onFixedVariant: colorTokens.tertiary[30],
    },
    error: {
        main: colorTokens.error[80],
        on: colorTokens.error[20],
        container: colorTokens.error[30],
        onContainer: colorTokens.error[90],
        fixed: colorTokens.error[90],
        onFixed: colorTokens.error[10],
        fixedDim: colorTokens.error[80],
        onFixedVariant: colorTokens.error[30],
    },
    warning: {
        main: colorTokens.warning[80],
        on: colorTokens.warning[20],
        container: colorTokens.warning[30],
        onContainer: colorTokens.warning[90],
        fixed: colorTokens.warning[90],
        onFixed: colorTokens.warning[10],
        fixedDim: colorTokens.warning[80],
        onFixedVariant: colorTokens.warning[30],
    },
    success: {
        main: colorTokens.success[80],
        on: colorTokens.success[20],
        container: colorTokens.success[30],
        onContainer: colorTokens.success[90],
        fixed: colorTokens.success[90],
        onFixed: colorTokens.success[10],
        fixedDim: colorTokens.success[80],
        onFixedVariant: colorTokens.success[30],
    },
    info: {
        main: colorTokens.tertiary[80],
        on: colorTokens.tertiary[20],
        container: colorTokens.tertiary[30],
        onContainer: colorTokens.tertiary[90],
        fixed: colorTokens.tertiary[90],
        onFixed: colorTokens.tertiary[10],
        fixedDim: colorTokens.tertiary[80],
        onFixedVariant: colorTokens.tertiary[30],
    },
    dawn: {
        main: colorTokens.neutral[10],
        on: colorTokens.neutral[25],
        container: colorTokens.neutral[30],
        onContainer: colorTokens.neutral[5],
        fixed: colorTokens.neutral[5],
        onFixed: colorTokens.neutral[30],
        fixedDim: colorTokens.neutral[10],
        onFixedVariant: colorTokens.neutral[30],
        contrastText: colorTokens.neutral[95],
    },
    dusk: {
        main: colorTokens.neutral[100],
        on: colorTokens.neutral[95],
        container: colorTokens.neutral[90],
        onContainer: colorTokens.neutral[5],
        fixed: colorTokens.neutral[90],
        onFixed: colorTokens.neutral[80],
        fixedDim: colorTokens.neutral[80],
        onFixedVariant: colorTokens.neutral[30],
        contrastText: colorTokens.neutral[10],
    },
    surface: {
        main: colorTokens.neutralVariant[5],
        on: colorTokens.neutralVariant[90],
        variant: colorTokens.neutralVariant[30],
        onVariant: colorTokens.neutralVariant[80],
        tint: colorTokens.primary[80],
        bright: colorTokens.neutralVariant[25],
        dim: colorTokens.neutralVariant[5],
        containerHighest: colorTokens.neutralVariant[20],
        containerHigh: colorTokens.neutralVariant[15],
        container: colorTokens.neutralVariant[10],
        containerLow: colorTokens.neutralVariant[5],
        containerLowest: colorTokens.neutralVariant[0],
    },
    inverse: {
        main: colorTokens.neutralVariant[90],
        on: colorTokens.neutral[20],
        primary: colorTokens.primary[40],
    },
    outline: {
        main: colorTokens.neutralVariant[60],
        variant: colorTokens.neutralVariant[30],
    },
    various: {
        shadow: colorTokens.neutral[0],
        skrim: colorTokens.neutral[0],
    },
    domain: {
        prod: colorTokens.neutral[40],
        acc: colorTokens.warning[40],
        test: colorTokens.error[40],
        other: colorTokens.primary[40],
    },
};
export default sdbThemeDarkSystemTokens;
